import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
            layout: "main-page-layout"
        }
    },
    {
        path: '/page/:pageurl',
        name: 'CustomPage',
        component: () => import("../views/Help.vue"),
    },
    // {
    //     path: '/help',
    //     name: 'Help',
    //     component: () => import("../views/Help.vue"),
    // },
    {
        path: '/oor',
        name: 'OpenOnlineResourses',
        component: () => import("../views/OpenOnlineResourses"),
    },
    // {
    //     path: '/guide',
    //     name: 'guides',
    //     component: () => import("../views/Guide"),
    // },
    // {
    //     path: '/guide_stud',
    //     name: 'StudentGuide',
    //     component: () => import("../views/StudentGuide"),
    // },
    // {
    //     path: "/guide_teach",
    //     name: "TeacherGuide",
    //     component: () => import("../views/TeacherGuide")
    // },
    // {
    //     path: "/order_uni",
    //     name: "UniOrders",
    //     component: () => import("../views/UniOrders")
    // },
    // {
    //     path: "/order_minobrmo",
    //     name: "MinobrOrders",
    //     component: () => import("../views/MinobrOrders")
    // },
    {
        path: "/appeal",
        name: "Appeal",
        component: () => import("../views/Appeal")
    },
    // {
    //     path: "/center",
    //     name: "Center",
    //     component: () => import("../views/Center")
    // },
    // {
    //     path: "/monitoring",
    //     name: "Monitoring",
    //     component: () => import("../views/Monitoring")
    // },
    {
        path: "/faq",
        name: "faq",
        component: () => import("../views/FAQ")
    },
    {
        path: "/admin",
        redirect: "/admin/stats"
    },
    {
        path: "/admin/pages",
        name: "PagesManage",
        component: () => import("../views/ControlPanel/ThePages"),
        meta: {
            layout: "cp-layout"
        }
    },
    {
        path: "/admin/hotline/calls",
        name: "HotlineCalls",
        component: () => import("../views/ControlPanel/HotlineCalls"),
        meta: {
            layout: "cp-layout"
        }
    },
    {
        path: "/admin/pages/new",
        name: "PagesAdding",
        component: () => import("../views/ControlPanel/PageAdd"),
        meta: {
            layout: "default-layout-with-vuetify",
            mode: "create"
        }
    },

    {
        path: "/admin/pages/:id",
        name: "PageEdit",
        component: () => import("../views/ControlPanel/PageAdd"),
        meta: {
            layout: "default-layout-with-vuetify",
            mode: "edit"
        }
    },
    {
        path: "/admin/pages/:id/copy",
        name: "PageCopy",
        component: () => import("../views/ControlPanel/PageAdd"),
        meta: {
            layout: "default-layout-with-vuetify",
            mode: "copy"
        }
    },
    {
        path: "/admin/stats",
        name: "StatsManage",
        component: () => import("../views/ControlPanel/Stats"),
        meta: {
            layout: "cp-layout"
        }
    },
    {
        path: "/admin/reports",
        name: "ReportsManage",
        component: () => import("../views/ControlPanel/Reports"),
        meta: {
            layout: "cp-layout"
        }
    },
    {
        path: "/admin/faq",
        name: "FAQManage",
        component: () => import("../views/ControlPanel/FAQ"),
        meta: {
            layout: "cp-layout"
        }
    },
    {
        path: "/404",
        name: "404",
        component: () => import("../views/404"),

    },
    {
        path: '*',
        name: 'CustomPage',
        component: () => import("../views/PageViewer"),
        meta: {
            layout: "default-layout-with-vuetify"
        }
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
